import React from "react";
import { Text as KonvaText } from "react-konva";
const Text = ({ shape, shapeProps }) => {
	return (
		<KonvaText
			key={shape.id}
			{...shapeProps}
			x={shape.x}
			y={shape.y}
			text={shape.text}
			fontSize={shape.fontSize} // Ensure font size is set
			width={shape.width}
			height={shape.height}
			fill="black"
			align="left"
			verticalAlign="top"
			padding={0} // Remove unwanted padding
		/>
	);
};

export default Text;
